export class contractForm {
  projectListing: string = '';
  contractStatus: string = null;
  offer_status: string = null;
  listingid: string = null;
  seller: any = null;
  sellerSolicitor: any = null;
  buyer: any = null;
  buyerSolicitor: any = null;
  contractPrice: number = 0;
  dateOffer: any = null;
  dateOfferTerms: any = null;
  cancelledDate: any = null;
  offerPrice: number = 0;
  settlementTerm: string = '';
  initialDepositAmount: number = 0;
  initialDepositAmountPayable: string = '';
  buildingPestTerm: string = '';
  balanceDepositAmount: number = 0;
  balanceDepositAmountPayable: string = '';
  financeTerm: string = '';
  comment: string = '';
  contractIssuedDate: any = null;
  contractReceivedDate: any = null;
  unconditionalDate: any;
  contractDate: any = null;
  collingExpire: any = null;
  totalDeposit: number = 0;
  financeDate: any = null;
  financeDateText: string = '';
  financeDateSatisfied: boolean = false;
  initialDeposit: number = 0;
  depositDue: any = null;
  depositeDueText: string = '';
  depositDuePaid: boolean = false;
  pastDue: any = null;
  pastDueText: string = '';
  pastDueSatisfied: boolean = false;
  balanceDeposit: number = 0;
  balanceDepositDue: any = null;
  balanceDepositDueText: string = '';
  balanceDepositDuePaid: boolean = false;
  settlement: any = null;
  settlementText: string = '';
  condition: contractCondition[] = [];
  listingAgent: string = null;
  managingAgent: string = null;
  sellingAgent: string = null;
  foreign: string = null;
  ownerOccupier: string = null;
  depositStakeholder: string = '';
  note: string = '';
}
export class contractCondition {
  contractCondition: string;
  contractConditionDue: Date;
  contractConditionDueText: string;
  contractConditionSatisfied: boolean;
}

export class contractFilter {
  keyword: string;
  agent: string;
  listing_address: string;
  project_name: string;
  contract_status: any;
  offer_status: string;
  condition_due: any;
  settlement_due: any;
  date: any;
}

export class contractEmail {
  to: any = '';
  from: any = 'remmi" <noreply@remmi.com.au>';
  subject: any = '';
  emailTemplate: any = '';
  body: any = '';
}
